import {
  useCallback
} from 'react';
import {
  useSelector
} from 'react-redux';
import {
  useNavigate,
} from 'react-router-dom';
import {
  selectIsAuthenticated
} from '@entities/session';

type LaunchGame = {
  launchGame(gameId: number): void;
};

export const useLaunchGame = (): LaunchGame => {
  const navigate = useNavigate();
  const isAuth = useSelector(selectIsAuthenticated);

  const handleLaunchGame = (gameId: number) => {
    if (!isAuth) navigate('/login');
    else navigate(`/games/${gameId}`);
  };

  const launchGame = useCallback(handleLaunchGame, []);

  return {
    launchGame,
  };
};
